<template>
  <div class="building-wrapper">
    <button class="building-btn" @click="cancelHouse">取消选择房屋</button>
    <div class="building-content">
      <div class="building-content-left">
        <div v-for="(building, building_key) in building_list" :key="building_key" :class="{active: curItem === building_key}" @click="tab(building_key, building.building_id)">{{building.building_name}}</div>
      </div>
      <div class="building-content-center"></div>
      <div class="building-content-right">
        <div v-for="(room, room_key) in room_list" :key="room_key" :class="{active: curItem === room_key}" @click="addRoom(room.full_room_name, room.room_id)" :id="room.room_id">{{room.full_room_name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'SelectVillage',
  data () {
    return {
      curItem: 0,
      building_list: [],
      room_list: []
    }
  },
  computed: {
    ...mapState(['villageId', 'roomId', 'roomName'])
  },
  created () {
    this.getBuildingList()
  },
  methods: {
    ...mapMutations(['changeArgs']),
    getBuildingList () {
      this.axios.get('/wechat/repair/getBuildingList/village_id/' + this.villageId)
        .then((res) => {
          if (res.data.status === 1) {
            this.building_list = res.data.data.building_list
            this.getRoomList(this.building_list[0].building_id)
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    getRoomList (buildingId) {
      this.axios.get('/wechat/repair/getRoomList/village_id/' + this.villageId + '/building_id/' + buildingId)
        .then((res) => {
          if (res.data.status === 1) {
            this.room_list = res.data.data.room_list
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    tab (buildingkey, buildingid) {
      this.curItem = buildingkey
      this.getRoomList(buildingid)
    },
    addRoom (roomname, roomid) {
      this.$messagebox({
        message: '确定为该房产报修吗？',
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: '确定'
      }).then(action => {
        if (action === 'confirm') { // 确认的回调
          // 存放roomid
          this.changeArgs({roomId: roomid, roomName: roomname})
          this.$router.push({name: 'Repair', query: {roomname: roomname}})
        }
      })
    },
    // 取消选择按钮
    cancelHouse () {
      this.changeArgs({roomId: 0, roomName: ''})
      this.$router.replace({name: 'Repair'})
    }
  }
}
</script>
<style scoped>
.building-wrapper {
  height: 100%;
}
.building-wrapper .building-content {
  display: flex;
  font-size: 15px;
  height: calc(100% - 60px);
  border-top: 1px solid #f7f7f7;
}
.building-wrapper .building-content .building-content-left {
  width: 120px;
  overflow-y: auto;
}
.building-wrapper .building-content .building-content-right {
  flex: 1;
  margin-left: 5px;
  overflow-y: auto;
}
.building-wrapper .building-content .building-content-left div, .building-wrapper .building-content .building-content-right div {
  height: 47px;
  line-height: 47px;
  text-align: center;
  background-color: #FFFFFF;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.building-wrapper .building-content .building-content-left div.active {
  background-color: #f8f8f8;
}
.building-wrapper .building-content .building-content-center {
  width: 5px;
  background-color: #f7f7f7;
}
.building-wrapper .building-btn {
  font-size: 15px;
  border-radius: 5px;
  background-color: #f8f8f8;
  color: #656565;
  padding: 4px 10px;
  margin: 15px 10px;
  border: 1px solid #e8e8e8;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/SelectBuilding.vue